export default "__VITE_ASSET__Dab9wd2F__"